import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PoweredByComponent } from './powered-by.component';
import { MaterialModule } from 'src/app/core/material/material.module';

@NgModule({
  declarations: [
    PoweredByComponent
  ],
  imports: [
    CommonModule,
    MaterialModule
  ],
  exports: [
    PoweredByComponent
  ]
})
export class PoweredByModule { }
